import { Card, Grid, Typography } from '@mui/material'

import { numberFormat } from '../../../../utils'
import { IStockReportSummary } from './types'

interface Props {
  summary?: IStockReportSummary
}

// signColor: ใช้สีตามเครื่องหมาย (ยอดสุทธิติดลบ = คืนมากกว่าตัด)
// warn: การ์ดเตือน — เป็น 0 คือดี ไม่ใช่แย่ จึงย้อมแดงเฉพาะตอนมีค่า
const items: {
  key: string
  label: string
  unit: string
  money: boolean
  color: string
  value: (s?: IStockReportSummary) => number
  signColor?: boolean
  warn?: boolean
}[] = [
  {
    key: 'reduceQuantity',
    label: 'ตัดสต๊อก',
    unit: 'ชิ้น',
    money: false,
    color: '#cf1322',
    value: (s) => Number(s?.reduceQuantity ?? 0),
  },
  {
    key: 'addQuantity',
    label: 'คืนสต๊อก',
    unit: 'ชิ้น (ยกเลิก/คืนของ)',
    money: false,
    color: '#389e0d',
    value: (s) => Number(s?.addQuantity ?? 0),
  },
  {
    key: 'netQuantity',
    label: 'สุทธิ',
    unit: 'ตัด − คืน (ชิ้น)',
    money: false,
    color: '#1677ff',
    value: (s) => Number(s?.netQuantity ?? 0),
    signColor: true,
  },
  {
    key: 'netCost',
    label: 'มูลค่าต้นทุน',
    unit: 'บาท (ต้นทุน ณ วันตัด)',
    money: true,
    color: '#eb2f96',
    value: (s) => Number(s?.netCost ?? 0),
  },
  {
    key: 'transactionCount',
    label: 'รายการเคลื่อนไหว',
    unit: 'รายการ',
    money: false,
    color: '#722ed1',
    value: (s) => Number(s?.transactionCount ?? 0),
  },
  {
    key: 'failureQuantity',
    label: 'ตัดสต๊อกไม่ได้',
    unit: 'ชิ้น (ยังตัดไม่ได้)',
    money: false,
    color: '#fa8c16',
    value: (s) => Number(s?.failureQuantity ?? 0),
    warn: true,
  },
]

const StockDeductionCards = ({ summary }: Props) => {
  return (
    <Grid container spacing={2} mb={2} columns={{ xs: 1, sm: 2, lg: 6 }}>
      {items.map((item) => {
        const value = item.value(summary)
        const color = item.signColor
          ? value >= 0
            ? '#1677ff'
            : '#cf1322'
          : item.warn
            ? value > 0
              ? '#fa8c16'
              : '#8c8c8c'
            : item.color

        return (
          <Grid item xs={1} key={item.key}>
            <Card
              variant="outlined"
              sx={{ p: 2, height: '100%', borderTop: `3px solid ${color}` }}
            >
              <Typography variant="body2" color="text.secondary">
                {item.label}
              </Typography>
              <Typography variant="h5" sx={{ mt: 1, fontWeight: 600, color }}>
                {item.money && '฿'}
                {numberFormat(value, item.money ? 2 : 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {item.unit}
              </Typography>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default StockDeductionCards
